/**
 * Program JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Program
 */
class Program {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get the tab buttons
        this.tabControllers    = $( '.js-program-tabs-button' );
        this.tabArchiveButtons = $( '.js-current-topics-read-more-btn' );

        // Get the program tabs
        this.programTabs = $( '.js-program-tab' );
        this.moreTabs = $( '.js-more-tabs' );

    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // A click event to control each tab-button
        this.tabControllers.each( ( e, current ) => {

            $( current ).on( 'click', ( e ) => {

                // Stop the normal behaviour of the link - we dont want to scroll to the content every time a tab
                // is changed
                Theme.Common.stop( e );

                // Get the correct tab to open from the links href attribute.
                const tabToControl = $( e.currentTarget ).attr( 'href' );

                // Control the visibility of the tabs
                this.hideTabs( tabToControl, false );

            });
        });
    }

    /**
     * This controls the tabs and sets the current aria-selected status to active button
     *
     * @param {string} activeTab The active tab to be shown
     * @param {boolean} onLoad Boolean to know if this function was launched on load
     */
    hideTabs( activeTab, onLoad ) {

        // Hide all the other tabs except the selected one
        $( activeTab ).siblings( '.js-program-tab' ).addClass( 'js-hidden' );
        $( activeTab ).removeClass( 'js-hidden' );

        // Control the active buttons layout and the aria-selected -attribute for
        // all of the buttons. First get the active tab button and
        // then the not active ones. A bit of traversing here to get the parent
        // li item, its siblings and their tab buttons to get what we want.
        const activeTabButton = $( activeTab + '-button' );
        const notActiveTab = activeTabButton.parent( 'li' ).siblings().find( '.js-program-tabs-button' );

        // Remove active indicators from not active tab buttons
        notActiveTab.attr( 'aria-selected', 'false' );
        notActiveTab.removeClass( 'active-tab' );

        // Add active indicators to active tab button
        $( activeTabButton ).attr( 'aria-selected', 'true' );
        $( activeTabButton ).addClass( 'active-tab' );

        // If the function was launched with a click of a tab button, move focus to the first title
        if ( onLoad == false ) {

            // Find the first card and its first heading and focus on that-
            $( activeTab ).find( '.js-tabs-item:first-child' ).find( '.js-tabs-title' ).attr( 'tabindex', '-1' ).focus();

            // If the function was launched on page load, see that other tab instances get treated
            // correctly as well, as in setting the first tab to be active.
        } else {

            // If more tabs sections exist on page load, reveal the first tab of the second tabs section
            if ( this.moreTabs.length > 0 ) {

                // Get the total number of previous tabs and add 1 to it to get the id
                // for the tab to be revealed in this instance
                const tabToShow = '#tab-' + ( parseInt( this.moreTabs.attr( 'previous-tabs' ) ) + 1 );

                // Make the button active and set aria selected to true
                $( tabToShow + '-button' ).addClass( 'active-tab' ).attr( 'aria-selected', 'true' );;

                // Show the wanted tab
                $( tabToShow ).siblings( '.js-program-tab' ).addClass( 'js-hidden' );
                $( tabToShow ).removeClass( 'js-hidden' );

                // Show the archive button related to the tab shown - simply change the activeTab to match the
                // tabToShow here. Notice though that its really important to do this here,
                // at the end of the function but just before the tabs button IF,
                // to not mess up with the rest of the tabs.
                activeTab = tabToShow;
            }
        };

        // Control the read more button, found on current-topics. Hide its sibling items and show the one we
        // want to be shown, which is the current tabs archive link. If there is no read more -button
        // associated with the selected tab, hide them all. Only do this when changing the tabs
        // in current-topics.dust as it is the only tabs section with archive
        // buttons (hence the patents class length check)
        if ( this.tabArchiveButtons.length > 0 && $( activeTab ).parents( '.js-current-topic-tabs' ).length > 0 ) {

            const activeTabReadMore = $( activeTab + '-read-more' );

            // Check if there is a read more link for the selected tab, then show it & hide others
            if (  activeTabReadMore.length > 0 ) {

                this.tabArchiveButtons.not( activeTabReadMore ).addClass( 'js-hidden' );

                // A small timeout to make sure the class is removed
                setTimeout( ()=>  {
                    activeTabReadMore.removeClass( 'js-hidden' );
                  }, 100 );

                // If no rear more links are found, hide all of them
            } else {
                this.tabArchiveButtons.addClass( 'js-hidden' );
            }
        }
    }


    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();

        // Throw in the first active tab as parameter, also notify the function that it was not fired by clicking a link
        this.hideTabs( '#tab-1', true );
        this.events();
    }
}

// Export the class reference.
module.exports = Program;



// WEBPACK FOOTER //
// ./assets/scripts/program.js